import { render } from "./MarqueeText.vue?vue&type=template&id=01129104&scoped=true"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"

import "./MarqueeText.vue?vue&type=style&index=0&id=01129104&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01129104"]])

export default __exports__